/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { System } from './System';
/**
 * Typed Arrays
 */

// tslint:disable:no-any

/**
 * Buffer utils
 */
export class Buffers {
  static from(arr) {
    if (arr instanceof DataView) {
      const dv = arr;
      return Buffers.fromArrayBuffer(dv.buffer, dv.byteOffset, dv.byteLength);
    }

    return new Buffers(arr);
  }

  static fromArrayBuffer(arr, byteOffset, byteLength) {
    return new Buffers(new Uint8Array(arr, byteOffset, byteLength));
  }

  static swapInline(tarray) {
    const arr = new Uint8Array(tarray.buffer, tarray.byteOffset, tarray.byteLength);
    const L = tarray.BYTES_PER_ELEMENT;

    if (L === 2) {
      for (let i = 0; i < tarray.byteLength; i += 2) {
        const a = arr[i];
        arr[i] = arr[i + 1];
        arr[i + 1] = a;
      }
    } else if (L === 4) {
      for (let i = 0; i < tarray.byteLength; i += 4) {
        const a = arr[i];
        const b = arr[i + 1];
        arr[i] = arr[i + 3];
        arr[i + 1] = arr[i + 2];
        arr[i + 2] = b;
        arr[i + 3] = a;
      }
    }
  }

  static swappedClone(tarray) {
    const to = new Uint8Array(tarray.byteLength);
    const from = new Uint8Array(tarray.buffer, tarray.byteOffset, tarray.byteLength);
    const L = tarray.BYTES_PER_ELEMENT;

    if (L === 2) {
      for (let i = 0; i < tarray.byteLength; i += 2) {
        to[i] = from[i + 1];
        to[i + 1] = from[i];
      }
    } else if (L === 4) {
      for (let i = 0; i < tarray.byteLength; i += 4) {
        to[i] = from[i + 3];
        to[i + 1] = from[i + 2];
        to[i + 2] = from[i + 1];
        to[i + 3] = from[i];
      }
    }

    return to.buffer;
  }

  constructor(arr) {
    this._currentType = arr.constructor;
    this._currentArray = arr;
  }

  as(type) {
    let buf = this;

    if (this._currentArray.byteOffset % type.BYTES_PER_ELEMENT !== 0) {
      buf = this.clone();
    }

    return new type(buf._currentArray.buffer, buf._currentArray.byteOffset, buf._currentArray.byteLength / type.BYTES_PER_ELEMENT);
  }

  asIs() {
    return this._currentArray;
  }

  cast(type) {
    return new Buffers(new type(this._currentArray));
  }

  reinterpret(type) {
    let buf = this; // tslint:disable-next-line:no-string-literal

    const bytesPerElement = type['BYTES_PER_ELEMENT'];

    if (this._currentArray.byteOffset % bytesPerElement !== 0) {
      buf = this.clone();
    }

    this._currentArray = new type(buf._currentArray.buffer, buf._currentArray.byteOffset, buf._currentArray.byteLength / bytesPerElement);
    this._currentType = type;
    return this;
  }

  clone() {
    const buffer = this._currentArray.buffer.slice(this._currentArray.byteOffset, this._currentArray.byteOffset + this._currentArray.byteLength);

    const T = this._currentType;
    const typedArray = new T(buffer, 0, this._currentArray.byteLength);
    return new Buffers(typedArray);
  }

  spread(factor) {
    const T = this._currentType;
    const array = new T(this._currentArray.length * factor);

    for (let index = 0; index < array.length; index++) {
      array[index] = this._currentArray[Math.floor(index / factor)];
    }

    return new Buffers(array);
  }

  correctByteOrder(endianess) {
    if (endianess === 'little' !== System.isLE()) {
      const T = this._currentType;
      return new Buffers(new T(Buffers.swappedClone(this._currentArray)));
    }

    return this;
  }

  correctByteOrderInline(endianess) {
    if (endianess === 'little' !== System.isLE()) {
      Buffers.swapInline(this._currentArray);
    }

    return this;
  }

}
//# sourceMappingURL=Buffers.js.map